import React from 'react';
import ElPrixDesktop from '@assets/decorations/elprix/ElPrixDesktop.svg';
import ElPrixMobile from '@assets/decorations/elprix/ElPrixMobile.svg';
import * as S from './Styles';

export const ElPrix = () => (
  <S.ElPrixWrapper>
    <S.DesktopWrapper>
      <ElPrixDesktop />
    </S.DesktopWrapper>
    <S.MobileWrapper>
      <ElPrixMobile />
    </S.MobileWrapper>
  </S.ElPrixWrapper>
);
